/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { styled, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, ButtonProps } from './Button';
import MaterialSymbol from './MaterialSymbol';

interface Props extends ButtonProps {
  text: string;
  onClick?: () => void;
}

const StyledButton = styled(Button)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  textDecoration: 'none',
  cursor: 'pointer',
  ...theme.typography.body2,
  color: theme.colors.primary500,
  padding: '2px 8px',
  marginLeft: '-8px',
  marginBottom: '16px',
  '& span': {
    fontWeight: 300,
    transform: 'rotate(-180deg)',
    marginRight: '8px',
  },
  '&:hover': {
    background: theme.colors.primary100,
  },
}));

export const BackButton = (props: Props) => {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };

  return (
    <StyledButton onClick={props.onClick ?? goBack} {...props}>
      <MaterialSymbol>arrow_right_alt</MaterialSymbol>
      <Typography variant='body2' color='inherit'>
        {props.text}
      </Typography>
    </StyledButton>
  );
};
